export const login = {
  login_form: {
    username: "",
    password: "",
    rememberMe: false,
  },
  forgot_form: {
    username: "",
  },
  register_form: {
    full_name: "",
    password: "",
    username: "",
    repeat_password: "",
    email: "",
    company_email: "",
    company_name:"",
    date_created: "",
    access_category: "",
    OPU: "",
  },
  verification_form: {
    code: "",
    username: "",
    password: "",
    repeat_password: "",
  },
  switch_class: "",
  show_hide_class: "",
  show_forgot_component: false,
  show_register_component: false,
  show_successVerified_component: false,
  show_verification_component: false,
  show_verifyemail_component: false,
  is_login_loading: false,
  is_forgot_loading: false,
  is_register_loading: false,
  is_submit: false,
  show_loading: false,
  user: {},
  is_authenticated: false,
};



// WEBPACK FOOTER //
// ./src/reducers/login/login.state.js